import { createAction } from '@reduxjs/toolkit';
export const HistoryActions = {
    // clear: createAction('history/clear'),
    // lock: createAction('history/lock'),
    // unlock: createAction('history/unlock'),
    // undo: createAction('history/undo'),
    // redo: createAction('history/redo'),
    // reset: createAction('history/reset'),
    undo: createAction('DESIGNER_UNDO'),
    redo: createAction('DESIGNER_REDO'),
    clear: createAction('DESIGNER_CLEAR'),
    reset: createAction('DESIGNER_RESET'),
    lock: createAction('DESIGNER_LOCK'),
    unlock: createAction('DESIGNER_UNLOCK'),
    record: createAction('DESIGNER_RECORD'),
    commit: createAction('DESIGNER_RECORD_COMMIT'),
    reject: createAction('DESIGNER_RECORD_REJECT'),
};
